import { gsap, ScrollTrigger } from 'gsap/all'
import { useLayoutEffect, useRef, MutableRefObject, useMemo } from 'react'
import { useIsLargeScreen } from 'src/helpers/layout'
import {
  createShowFromBottomAnimation,
  createShowFromLeftAnimation,
  createShowFromRightAnimation,
  isInitialLoad
} from 'src/helpers/animations'

gsap.registerPlugin(ScrollTrigger)

export const useHeroAnimation = (
  subtitleRef: MutableRefObject<HTMLHeadingElement>,
  pageTitleRef: MutableRefObject<HTMLHeadingElement>,
  contentRef: MutableRefObject<HTMLParagraphElement>,
  buttonWrapperRef: MutableRefObject<HTMLDivElement>,
  badgesRef: MutableRefObject<HTMLDivElement>,
  backButtonRef?: MutableRefObject<HTMLDivElement>,
  childrenRef?: MutableRefObject<HTMLDivElement>
) => {
  const timeline = useRef(gsap.timeline())
  const isLarge = useIsLargeScreen()
  const shouldAnimateWidgets = useMemo(() => isInitialLoad(), [])

  const animations = () => {
    if (backButtonRef?.current) {
      createShowFromLeftAnimation(timeline.current, backButtonRef.current)
    }

    if (subtitleRef.current) {
      createShowFromLeftAnimation(
        timeline.current,
        subtitleRef.current,
        backButtonRef?.current || undefined
      )
    }

    if (pageTitleRef.current) {
      createShowFromLeftAnimation(
        timeline.current,
        pageTitleRef.current,
        subtitleRef.current || undefined
      )
    }

    if (badgesRef.current) {
      if (shouldAnimateWidgets) {
        createShowFromRightAnimation(
          timeline.current,
          badgesRef.current,
          subtitleRef.current || undefined,
          "<" // Start at the same time as the title
        )
      } else {
        gsap.set(badgesRef.current, { opacity: 1, x: 0 })
      }
    }

    if (contentRef.current) {
      createShowFromLeftAnimation(
        timeline.current,
        contentRef.current,
        subtitleRef.current || undefined
      )
    }

    if (buttonWrapperRef.current) {
      createShowFromLeftAnimation(
        timeline.current,
        buttonWrapperRef.current,
        subtitleRef.current || undefined
      )
    }

    if (childrenRef?.current) {
      createShowFromBottomAnimation(
        timeline.current,
        childrenRef.current,
        pageTitleRef.current || undefined,
        '<'
      )
    }

    ScrollTrigger.sort()
  }

  useLayoutEffect(() => {
    if (isLarge === null) {
      return
    }

    animations()
  }, [isLarge])
}

export default {}
